export const DEFAULT_CALENDAR_LEAVE_REQUEST_HEAD_COLOUR = '#4b99f5';
export const DEFAULT_CALENDAR_PENDING_LEAVE_REQUEST_HEAD_COLOUR = '#ffdb69';

type Colour = { r: number; g: number; b: number };

export const lightenHexColour = (hex: string, percentage: number) => changeHexColour(hex, -percentage);

function changeHexColour(hex: string, percentage: number) {
    if (hex.charAt(0) === '#') {
        hex = hex.slice(1);
    }

    const { r, g, b } = parseHexColour(hex);

    let newR, newG, newB: number;

    if (percentage > 0) {
        newR = Math.max(0, Math.round(r * (1 - percentage / 100)));
        newG = Math.max(0, Math.round(g * (1 - percentage / 100)));
        newB = Math.max(0, Math.round(b * (1 - percentage / 100)));
    } else {
        newR = Math.min(255, Math.round(r + ((255 - r) * -percentage) / 100));
        newG = Math.min(255, Math.round(g + ((255 - g) * -percentage) / 100));
        newB = Math.min(255, Math.round(b + ((255 - b) * -percentage) / 100));
    }

    return buildHexColour(newR, newG, newB);
}

function parseHexColour(colour: string): Colour {
    const r = parseInt(colour.substring(0, 2), 16);
    const g = parseInt(colour.substring(2, 4), 16);
    const b = parseInt(colour.substring(4, 6), 16);
    return { r, g, b };
}

function buildHexColour(r: number, g: number, b: number): string {
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

export const hexToRgba = (hex: string, alpha: number = 0.1): string => {
    const num = parseInt(hex.replace('#', ''), 16);
    const r = (num >> 16) & 0xff;
    const g = (num >> 8) & 0xff;
    const b = num & 0xff;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
